import React from 'react';
import WorkflowTemplatesPage from '../../admin/Workflow/WorkflowTemplatesPage';

const StaffWorkflowTemplatesPage = () => {
  // Pass isStaffPortal=true to the component to ensure it uses staff-specific endpoints
  return <WorkflowTemplatesPage isStaffPortal={true} />;
};

export default StaffWorkflowTemplatesPage;
